module.exports = __webpack_public_path__ + "static/media/ipad_air.fefdfbc2.jpg";